import _ from "lodash";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button } from "react-spark";

import { withForm } from "../forms/form/WithForm";

class URCButton extends Component {
  static defaultProps = {
    children: null,
    disabled: false,
    fullWidthAtSmallViewport: false,
    isDisplayed: true,
    loading: false,
    variant: "primary",
    type: "button",
    onClick: () => {}
  };

  static propTypes = {
    id: PropTypes.string.isRequired,
    children: PropTypes.node,
    disabled: PropTypes.bool,
    fullWidthAtSmallViewport: PropTypes.bool,
    isDisplayed: PropTypes.bool,
    loading: PropTypes.bool,
    name: PropTypes.string.isRequired,
    variant: PropTypes.string,
    type: PropTypes.oneOf(['button', 'submit', 'reset']),
    onClick: PropTypes.func,
    className: PropTypes.string
  };

  resolveDisabled() {
    if (this.props.context && this.props.contextDisable) {
      return !this.props.context.valid || Boolean(this.props.disabled);
    }

    return this.props.disabled;
  }

  submit(event) {
    // Only prevent default for non-submit buttons
    if (this.props.type !== 'submit') {
      event.preventDefault();
      event.stopPropagation();
    }

    if (!this.props.loading) {
      // For submit buttons, let the form handle submission naturally
      if (this.props.type === 'submit') {
        // Just call onClick if provided, but don't prevent form submission
        this.props.onClick(event);
      } else {
        // For regular buttons, use the existing behavior
        if (_.get(this.props, "context.onSubmit", false)) {
          this.props.context.onSubmit(event);
        }
        this.props.onClick(event);
      }
    } else if (this.props.type === 'submit') {
      // If loading and it's a submit button, prevent submission
      event.preventDefault();
      event.stopPropagation();
    }
  }

  render() {
    const {
      children,
      fullWidthAtSmallViewport,
      id,
      isDisplayed,
      loading,
      name,
      variant,
      className,
      style,
      type,
    } = this.props;

    const isDisabled = this.resolveDisabled();
    if (isDisplayed === false) {
      return null;
    }

    return (
      <Button
        id={id}
        disabled={isDisabled}
        fullWidthAtSmallViewport={fullWidthAtSmallViewport}
        onClick={event => this.submit(event)}
        spinner={loading}
        name={name}
        variant={variant}
        className={className}
        style={style}
        type={type}
      >
        {children}
      </Button>
    );
  }
}

export default URCButton;
export const SubmitButton = withForm(URCButton);
